const rankings = [
  { rank: 1, title: '《无声证词》', meta: '悬疑 · 9.2分', hot: true, change: 'new' },
  { rank: 2, title: '《暗夜追击》', meta: '动作 · 9.2分', hot: true, change: 'up' },
  { rank: 3, title: '《梦境奇旅》', meta: '动画 · 9.5分', hot: true, change: 'up' },
  { rank: 4, title: '《那年星空下》', meta: '爱情 · 8.8分', hot: false, change: 'same' },
  { rank: 5, title: '《星际迷途》', meta: '科幻 · 8.5分', hot: false, change: 'down' },
  { rank: 6, title: '《归途》', meta: '剧情 · 8.7分', hot: false, change: 'up' },
];

export default function RankingSection() {
  return (
    <section id="ranking" className="bg-background-100">
      <div className="w-full px-4 md:px-6 py-14 md:py-20">
        <div className="max-w-[1400px] mx-auto">
          <div className="text-center mb-12">
            <span className="inline-block text-xs font-semibold uppercase tracking-widest text-accent-400 mb-3">RANKING</span>
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-50">热度榜单</h2>
            <p className="mt-3 text-sm text-foreground-500 max-w-[500px] mx-auto">全网影迷都在看的爆款内容，实时热度排名</p>
          </div>

          <div className="max-w-[700px] mx-auto bg-background-200/60 rounded-2xl border border-background-200/40 overflow-hidden">
            {rankings.map((r, i) => (
              <div
                key={i}
                className={`flex items-center gap-4 px-6 py-4 transition-colors duration-200 cursor-pointer ${
                  i < rankings.length - 1 ? 'border-b border-background-200/30' : ''
                } hover:bg-background-300/40`}
              >
                <div className={`w-8 h-8 rounded-lg flex items-center justify-center flex-shrink-0 ${
                  r.rank === 1
                    ? 'bg-primary-500 text-background-50'
                    : r.rank === 2
                    ? 'bg-primary-500/70 text-background-50'
                    : r.rank === 3
                    ? 'bg-primary-500/40 text-foreground-100'
                    : 'bg-background-300/50 text-foreground-500'
                }`}>
                  <span className="text-sm font-bold">{r.rank}</span>
                </div>
                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-2">
                    <h3 className="text-sm font-semibold text-foreground-100 truncate">{r.title}</h3>
                    {r.hot && <i className="ri-fire-line text-xs text-accent-400 flex-shrink-0"></i>}
                  </div>
                  <p className="text-xs text-foreground-500 mt-0.5">{r.meta}</p>
                </div>
                <div className="flex-shrink-0">
                  {r.change === 'new' && <span className="text-xs px-2 py-1 rounded bg-accent-500/15 text-accent-400 font-medium whitespace-nowrap">NEW</span>}
                  {r.change === 'up' && <i className="ri-arrow-up-s-line text-accent-400"></i>}
                  {r.change === 'down' && <i className="ri-arrow-down-s-line text-foreground-600"></i>}
                  {r.change === 'same' && <i className="ri-subtract-line text-foreground-600"></i>}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}